import { SvgIcon } from '@mui/material';
import { ReactComponent as errorSVG } from './error.svg';

export default function ImgErrorNotFound(props) {
  return <SvgIcon component={errorSVG} viewBox="0 0 108 108" {...props} />;
}